import{a as e}from"./chunk-KERBADJJ.js";import{n as o,o as r}from"./chunk-PC2QB7VM.js";var f=new o({locale:[e,r]});export{f as a};
